// extracted by mini-css-extract-plugin
export default {"container":"PersonalInformation_container__nDT2e","button":"PersonalInformation_button__oBqt0","cancel_subscription_button":"PersonalInformation_cancel_subscription_button__JVUwt"};